// extracted by mini-css-extract-plugin
export default {"drawer":"KQ","drawerheader":"LQ","retake_quiz_bottom_bar":"MQ","extra_drawer":"NQ","not_answered_questions":"OQ","question_ui":"PQ","accordion_details":"QQ","retake_quiz":"RQ","accordions":"SQ","accordion_root":"TQ","accordion_summary_text":"UQ","animation":"VQ","show_animation":"WQ","overflow_hidden":"XQ"};
    if(module.hot) {
      // 1713969936124
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  